import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // loggedIn: router.app.$cookie.get('x-access-token')
  },
  mutations: {
  },
  actions: {
    login({commit}, user) {
      // return new Promise((resolve, reject) => {
        axios.post('login.php', user)
        .then((sessionid) => {
          if (sessionid.data.success) {
            router.app.$cookie.set('x-access-token', sessionid.data.session_id)
            router.push('tests')
          }else {
            return 'Hibás felhasználónév vagy jelszó!'
          }
          // resolve(sessionid.data)
        })
        .catch(error => {
          return error
          // reject(error)
        })
      // })
    }
  }
})
